import React from "react";
import NavigationButton from "@shared/NavigationButton";
import DynamicHtml from "@common/DynamicHtml";

const NavigationSection = ({ 
  backButtonLabel, 
  backButtonIcon, 
  backButtonIconPosition,
  navigateBackward, 
  forwardButtonLabel, 
  forwardButtonIcon,
  forwardButtonIconPosition,
  navigateForward, 
  headerText, 
  safeChannelName, 
  channel,
  resultName,
  hierarchyShortName,
  stateName,
  zipCode,
  pageName,
  pageState
}) => {
  const uniqueIdentifier = pageState ? `${safeChannelName}-${pageState}-${pageName}` : `${safeChannelName}-${pageName}`;
  return (
  <>
    <div className={`norstella-pf-nav-left norstella-pf-${uniqueIdentifier}-nav-left`}>
      <NavigationButton
        label={backButtonLabel}
        icon={backButtonIcon}
        className={"norstella-pf-back-btn"}
        iconPosition={backButtonIconPosition}
        onClick={navigateBackward}
        identifier={uniqueIdentifier}
      />
    </div>
    {headerText && headerText.trim() !== "" && (
      <div className={`norstella-pf-header-section norstella-pf-${uniqueIdentifier}-header-section`}>
        <DynamicHtml
          part="pfDivHeaderText"
          input={headerText}
          className={`norstella-pf-nav-header norstella-pf-${uniqueIdentifier}-nav-header`}
          channelName={channel.channelName}
          resultname={resultName}
          hierarchyShortName={hierarchyShortName}
          stateName={stateName}
          zipCode={zipCode} 
        />
      </div>
    )}
    {!channel?.isNoInsurance && (
      <div className={`norstella-pf-nav-right norstella-pf-${uniqueIdentifier}-nav-right`}>
        <NavigationButton
          label={forwardButtonLabel}
          icon={forwardButtonIcon}
          className={"norstella-pf-forward-btn"}
          identifier={uniqueIdentifier}
          onClick={navigateForward}
          iconPosition={forwardButtonIconPosition}
        />
      </div>
    )}
  </>
  )
};

export default NavigationSection;
